import React, { useState, useEffect } from "react";
import { ref, get } from "firebase/database"; // assuming you're using Firebase
import { auth, database } from "../../../../firebase";

const UserCreate = ({
  showModal,
  closeModal,
  user,
  handleCreateUser,
  handleEditUser,
}) => {
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("User");
  const [companyId, setCompanyId] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        setEmail(user.email || "");
        setRole(user.role || "User");
      }
    };

    fetchUserData();
  }, [user]);

  const handleSubmit = async () => {
    debugger
    if (user) {
      // Edit existing user
      handleEditUser(user.uid, { email, role, companyId });
    } else {
      const currentUser = auth.currentUser; // Get current user
      const currentUid = currentUser ? currentUser.uid : null;
      const userRef = ref(database, "users/" + currentUid);
      const snapshot = await get(userRef);
      if (snapshot.exists()) {
        const userData = snapshot.val();
        setCompanyId(userData.companyId);
      }
      // Create new user
      handleCreateUser(email, companyId, role);
    }
    closeModal();
  };

  return (
    showModal && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-50 z-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-lg shadow-lg w-96">
          <div className="flex justify-between items-center mb-4">
            <span className="text-xl font-bold">
              {user ? "Edit User" : "Create New User"}
            </span>
            <button className="text-red-500 text-3xl" onClick={closeModal}>
              &times;
            </button>
          </div>
          <div className="modal-body">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="User Email"
              className="p-2 border rounded mb-4 w-full"
            />
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="p-2 border rounded mb-4 w-full"
            >
              <option value="User">User</option>
            </select>
            <button
              onClick={handleSubmit}
              className="bg-blue-500 text-white p-3 rounded-lg w-full"
            >
              {user ? "Update User" : "Create User"}
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default UserCreate;
